module.exports = __webpack_public_path__ + "static/img/city-mob-red-3.f7e5f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-3.png
// module id = 1082
// module chunks = 173